{
  "generatedAt": "2026-11-03T13:39:35.622Z",
  "ships": [
    {
      "slug": "adder",
      "fdSymbol": "Adder",
      "name": "Adder",
      "manufacturer": "Zorgon Peterson",
      "class": 1,
      "hullCost": 40833,
      "retailCost": 87808,
      "speed": 220,
      "boost": 320,
      "boostEnergy": 9,
      "hullMass": 35,
      "masslock": 7,
      "baseShieldStrength": 60,
      "baseArmour": 90,
      "hardness": 35,
      "heatCapacity": 170,
      "crew": 2,
      "pitch": 38,
      "roll": 100,
      "yaw": 14,
      "reserveFuelCapacity": 0.36,
      "slots": {
        "core": [
          3,
          3,
          3,
          1,
          2,
          3,
          3
        ],
        "hardpoints": [
          2,
          1,
          1,
          0,
          0
        ],
        "optional": [
          3,
          3,
          2,
          2,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 3,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 3,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 3,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 1,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 2,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 3,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 1,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size2",
          "kind": "optional",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size3_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size3_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size3_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size1_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size2_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size3_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Adder_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Adder_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Adder_Armour_Grade2",
          "cost": 35123,
          "mass": 3,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Adder_Armour_Grade3",
          "cost": 79027,
          "mass": 5,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Adder_Armour_Mirrored",
          "cost": 186767,
          "mass": 5,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Adder_Armour_Reactive",
          "cost": 206963,
          "mass": 5,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "alliance_challenger",
      "fdSymbol": "Alliance_Challenger",
      "name": "Alliance Challenger",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 29569804,
      "retailCost": 30472252,
      "speed": 204,
      "boost": 310,
      "boostEnergy": 19,
      "hullMass": 450,
      "masslock": 13,
      "baseShieldStrength": 220,
      "baseArmour": 300,
      "hardness": 65,
      "heatCapacity": 316,
      "crew": 2,
      "pitch": 32,
      "roll": 90,
      "yaw": 16,
      "reserveFuelCapacity": 0.77,
      "slots": {
        "core": [
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "hardpoints": [
          3,
          2,
          2,
          2,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          6,
          3,
          3,
          2,
          2,
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 4,
          "index": 6,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 4,
          "index": 7,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military03",
          "kind": "optional",
          "size": 4,
          "index": 8,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "TypeX_3_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "TypeX_3_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "TypeX_3_Armour_Grade2",
          "cost": 12188900,
          "mass": 40,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "TypeX_3_Armour_Grade3",
          "cost": 27425026,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "TypeX_3_Armour_Mirrored",
          "cost": 64814480,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "TypeX_3_Armour_Reactive",
          "cost": 71823097,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "alliance_chieftain",
      "fdSymbol": "Alliance_Chieftain",
      "name": "Alliance Chieftain",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 18612476,
      "retailCost": 19382252,
      "speed": 230,
      "boost": 330,
      "boostEnergy": 19,
      "hullMass": 400,
      "masslock": 13,
      "baseShieldStrength": 200,
      "baseArmour": 280,
      "hardness": 65,
      "heatCapacity": 289,
      "crew": 2,
      "pitch": 39,
      "roll": 92,
      "yaw": 16,
      "reserveFuelCapacity": 0.77,
      "slots": {
        "core": [
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "hardpoints": [
          3,
          3,
          2,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          5,
          4,
          2,
          2,
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 4,
          "index": 5,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 4,
          "index": 6,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military03",
          "kind": "optional",
          "size": 4,
          "index": 7,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "TypeX_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "TypeX_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "TypeX_Armour_Grade2",
          "cost": 7752900,
          "mass": 40,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "TypeX_Armour_Grade3",
          "cost": 17444026,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "TypeX_Armour_Mirrored",
          "cost": 41226050,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "TypeX_Armour_Reactive",
          "cost": 45683967,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "alliance_crusader",
      "fdSymbol": "Alliance_Crusader",
      "name": "Alliance Crusader",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 22096565,
      "retailCost": 22866341,
      "speed": 180,
      "boost": 300,
      "boostEnergy": 19,
      "hullMass": 500,
      "masslock": 13,
      "baseShieldStrength": 200,
      "baseArmour": 300,
      "hardness": 65,
      "heatCapacity": 316,
      "crew": 4,
      "pitch": 32,
      "roll": 80,
      "yaw": 16,
      "reserveFuelCapacity": 0.77,
      "slots": {
        "core": [
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "hardpoints": [
          3,
          2,
          2,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          5,
          3,
          3,
          2,
          2,
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 4,
          "index": 6,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 4,
          "index": 7,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military03",
          "kind": "optional",
          "size": 4,
          "index": 8,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "TypeX_2_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "TypeX_2_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "TypeX_2_Armour_Grade2",
          "cost": 9146536,
          "mass": 40,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "TypeX_2_Armour_Grade3",
          "cost": 20579706,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "TypeX_2_Armour_Mirrored",
          "cost": 48636707,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "TypeX_2_Armour_Reactive",
          "cost": 53895965,
          "mass": 78,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "anaconda",
      "fdSymbol": "Anaconda",
      "name": "Anaconda",
      "manufacturer": "Faulcon DeLacy",
      "class": 3,
      "hullCost": 142456440,
      "retailCost": 146969451,
      "speed": 180,
      "boost": 240,
      "boostEnergy": 27,
      "hullMass": 400,
      "masslock": 23,
      "baseShieldStrength": 350,
      "baseArmour": 525,
      "hardness": 65,
      "heatCapacity": 334,
      "crew": 4,
      "pitch": 25,
      "roll": 60,
      "yaw": 10,
      "reserveFuelCapacity": 1.07,
      "slots": {
        "core": [
          8,
          7,
          6,
          5,
          8,
          8,
          5
        ],
        "hardpoints": [
          4,
          3,
          3,
          3,
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          7,
          6,
          6,
          6,
          5,
          5,
          5,
          {
            "class": 5,
            "name": "Military"
          },
          4,
          4,
          4,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 8,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 7,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 6,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 8,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 8,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint8",
          "kind": "hardpoint",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint7",
          "kind": "utility",
          "size": 0,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint8",
          "kind": "utility",
          "size": 0,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "size": 7,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size6",
          "kind": "optional",
          "size": 6,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size5",
          "kind": "optional",
          "size": 5,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 5,
          "index": 7,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot09_Size4",
          "kind": "optional",
          "size": 4,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size4",
          "kind": "optional",
          "size": 4,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot11_Size4",
          "kind": "optional",
          "size": 4,
          "index": 10,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot12_Size2",
          "kind": "optional",
          "size": 2,
          "index": 11,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot13_Size1",
          "kind": "optional",
          "size": 1,
          "index": 12,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 13,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size8_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size7_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size6_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size8_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size8_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint8",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size6_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot12_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Anaconda_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Anaconda_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Anaconda_Armour_Grade2",
          "cost": 58787780,
          "mass": 30,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Anaconda_Armour_Grade3",
          "cost": 132272505,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Anaconda_Armour_Mirrored",
          "cost": 312604021,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Anaconda_Armour_Reactive",
          "cost": 346406995,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "asp",
      "fdSymbol": "Asp",
      "name": "Asp Explorer",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 6145793,
      "retailCost": 6661154,
      "speed": 250,
      "boost": 340,
      "boostEnergy": 13,
      "hullMass": 280,
      "masslock": 11,
      "baseShieldStrength": 140,
      "baseArmour": 210,
      "hardness": 52,
      "heatCapacity": 272,
      "crew": 2,
      "pitch": 38,
      "roll": 100,
      "yaw": 10,
      "reserveFuelCapacity": 0.63,
      "slots": {
        "core": [
          5,
          5,
          5,
          4,
          4,
          5,
          5
        ],
        "hardpoints": [
          2,
          2,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          5,
          3,
          3,
          3,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 5,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 4,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 5,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "size": 3,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size5_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size4_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size5_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Asp_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Asp_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Asp_Armour_Grade2",
          "cost": 2664461,
          "mass": 21,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Asp_Armour_Grade3",
          "cost": 5995038,
          "mass": 42,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Asp_Armour_Mirrored",
          "cost": 14168274,
          "mass": 42,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Asp_Armour_Reactive",
          "cost": 15700339,
          "mass": 42,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "asp_scout",
      "fdSymbol": "Asp_Scout",
      "name": "Asp Scout",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 3819823,
      "retailCost": 3961154,
      "speed": 220,
      "boost": 300,
      "boostEnergy": 13,
      "hullMass": 150,
      "masslock": 8,
      "baseShieldStrength": 120,
      "baseArmour": 180,
      "hardness": 52,
      "heatCapacity": 210,
      "crew": 2,
      "pitch": 40,
      "roll": 110,
      "yaw": 15,
      "reserveFuelCapacity": 0.47,
      "slots": {
        "core": [
          4,
          4,
          4,
          3,
          4,
          4,
          4
        ],
        "hardpoints": [
          2,
          2,
          1,
          1,
          0,
          0
        ],
        "optional": [
          5,
          4,
          3,
          3,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 3,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 4,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size3_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size4_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Asp_Scout_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Asp_Scout_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Asp_Scout_Armour_Grade2",
          "cost": 1584461,
          "mass": 21,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Asp_Scout_Armour_Grade3",
          "cost": 3565038,
          "mass": 42,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Asp_Scout_Armour_Mirrored",
          "cost": 8425374,
          "mass": 42,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Asp_Scout_Armour_Reactive",
          "cost": 9336439,
          "mass": 42,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "beluga",
      "fdSymbol": "Beluga",
      "name": "Beluga Liner",
      "manufacturer": "Saud Kruger",
      "class": 3,
      "hullCost": 79694761,
      "retailCost": 84532764,
      "speed": 200,
      "boost": 280,
      "boostEnergy": 19,
      "hullMass": 950,
      "masslock": 18,
      "baseShieldStrength": 280,
      "baseArmour": 280,
      "hardness": 60,
      "heatCapacity": 283,
      "crew": 4,
      "pitch": 25,
      "roll": 60,
      "yaw": 17,
      "reserveFuelCapacity": 0.81,
      "slots": {
        "core": [
          6,
          7,
          7,
          8,
          6,
          5,
          7
        ],
        "hardpoints": [
          2,
          2,
          2,
          2,
          2,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          6,
          6,
          6,
          5,
          5,
          4,
          3,
          3,
          3,
          3,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 7,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 7,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 8,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 5,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 7,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size6",
          "kind": "optional",
          "size": 6,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size4",
          "kind": "optional",
          "size": 4,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "size": 3,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size3",
          "kind": "optional",
          "size": 3,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size3",
          "kind": "optional",
          "size": 3,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot11_Size3",
          "kind": "optional",
          "size": 3,
          "index": 10,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot12_Size1",
          "kind": "optional",
          "size": 1,
          "index": 11,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 12,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size7_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size7_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size8_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size5_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size7_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_PassengerCabin_Size6_Class2",
          "moduleName": "BC Passenger Cabin"
        },
        {
          "slotName": "Slot04_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_PassengerCabin_Size6_Class2",
          "moduleName": "BC Passenger Cabin"
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_PassengerCabin_Size4_Class2",
          "moduleName": "BC Passenger Cabin"
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_PassengerCabin_Size4_Class2",
          "moduleName": "BC Passenger Cabin"
        },
        {
          "slotName": "Slot07_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "BelugaLiner_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "BelugaLiner_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "BelugaLiner_Armour_Grade2",
          "cost": 33813105,
          "mass": 83,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "BelugaLiner_Armour_Grade3",
          "cost": 76079487,
          "mass": 165,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "BelugaLiner_Armour_Mirrored",
          "cost": 179801189,
          "mass": 165,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "BelugaLiner_Armour_Reactive",
          "cost": 199243724,
          "mass": 165,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "explorer_nx",
      "fdSymbol": "Explorer_NX",
      "name": "Caspian Explorer",
      "manufacturer": "Zorgon Peterson",
      "class": 3,
      "hullCost": 189326510,
      "retailCost": 194861290,
      "speed": 210,
      "boost": 290,
      "boostEnergy": 25,
      "hullMass": 950,
      "masslock": 19,
      "baseShieldStrength": 500,
      "baseArmour": 345,
      "hardness": 60,
      "heatCapacity": 250,
      "crew": 4,
      "pitch": 30,
      "roll": 75,
      "yaw": 14,
      "reserveFuelCapacity": 1.14,
      "slots": {
        "core": [
          8,
          7,
          8,
          5,
          7,
          8,
          7
        ],
        "hardpoints": [
          3,
          2,
          2,
          2,
          2,
          2,
          2,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          7,
          6,
          6,
          5,
          5,
          5,
          5,
          4,
          4,
          3,
          2,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 8,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 7,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 8,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 8,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 7,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "size": 7,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size5",
          "kind": "optional",
          "size": 5,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size4",
          "kind": "optional",
          "size": 4,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size4",
          "kind": "optional",
          "size": 4,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size3",
          "kind": "optional",
          "size": 3,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot11_Size2",
          "kind": "optional",
          "size": 2,
          "index": 10,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot12_Size1",
          "kind": "optional",
          "size": 1,
          "index": 11,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot13_Size1",
          "kind": "optional",
          "size": 1,
          "index": 12,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot14_Size1",
          "kind": "optional",
          "size": 1,
          "index": 13,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 14,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size8_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size7_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Overcharge_Size8_Class1",
          "moduleName": "Frame Shift Drive (SCO)"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size8_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size7_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size6_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot13_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "Slot14_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_DockingComputer_Advanced",
          "moduleName": "Advanced Docking Computer"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Explorer_NX_Armour_Grade1_Default",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Explorer_NX_Armour_Grade1_Default",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mk II Ablative Lightweight",
          "symbol": "Explorer_NX_Armour_Grade1",
          "cost": 9743070,
          "mass": 15,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mk II Ablative Reinforced",
          "symbol": "Explorer_NX_Armour_Grade2",
          "cost": 77944520,
          "mass": 30,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mk II Ablative Military Grade",
          "symbol": "Explorer_NX_Armour_Grade3",
          "cost": 175375160,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mk II Ablative Mirrored",
          "symbol": "Explorer_NX_Armour_Mirrored",
          "cost": 414469960,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Mk II Ablative Reactive",
          "symbol": "Explorer_NX_Armour_Reactive",
          "cost": 459288060,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "cobra_mk_iii",
      "fdSymbol": "CobraMkIII",
      "name": "Cobra Mk III",
      "manufacturer": "Faulcon DeLacy",
      "class": 1,
      "hullCost": 208372,
      "retailCost": 349718,
      "speed": 280,
      "boost": 400,
      "boostEnergy": 10,
      "hullMass": 180,
      "masslock": 8,
      "baseShieldStrength": 80,
      "baseArmour": 120,
      "hardness": 35,
      "heatCapacity": 225,
      "crew": 2,
      "pitch": 40,
      "roll": 100,
      "yaw": 10,
      "reserveFuelCapacity": 0.49,
      "slots": {
        "core": [
          4,
          4,
          4,
          3,
          3,
          3,
          4
        ],
        "hardpoints": [
          2,
          2,
          1,
          1,
          0,
          0
        ],
        "optional": [
          4,
          4,
          4,
          2,
          2,
          2,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 3,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size4",
          "kind": "optional",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size3_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "CobraMkIII_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "CobraMkIII_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "CobraMkIII_Armour_Grade2",
          "cost": 139887,
          "mass": 14,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "CobraMkIII_Armour_Grade3",
          "cost": 341746,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "CobraMkIII_Armour_Mirrored",
          "cost": 734407,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "CobraMkIII_Armour_Reactive",
          "cost": 824285,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "cobra_mk_iv",
      "fdSymbol": "CobraMkIV",
      "name": "Cobra Mk IV",
      "manufacturer": "Faulcon DeLacy",
      "class": 1,
      "hullCost": 623374,
      "retailCost": 764720,
      "speed": 200,
      "boost": 300,
      "boostEnergy": 10,
      "hullMass": 210,
      "masslock": 8,
      "baseShieldStrength": 120,
      "baseArmour": 120,
      "hardness": 35,
      "heatCapacity": 228,
      "crew": 2,
      "pitch": 30,
      "roll": 90,
      "yaw": 10,
      "reserveFuelCapacity": 0.51,
      "slots": {
        "core": [
          4,
          4,
          4,
          3,
          3,
          3,
          4
        ],
        "hardpoints": [
          2,
          2,
          1,
          1,
          1,
          0,
          0
        ],
        "optional": [
          4,
          4,
          4,
          4,
          3,
          3,
          2,
          2,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 3,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size4",
          "kind": "optional",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size4",
          "kind": "optional",
          "size": 4,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "size": 3,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "size": 3,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size3_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "CobraMkIV_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "CobraMkIV_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "CobraMkIV_Armour_Grade2",
          "cost": 305887,
          "mass": 14,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "CobraMkIV_Armour_Grade3",
          "cost": 688246,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "CobraMkIV_Armour_Mirrored",
          "cost": 1605907,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "CobraMkIV_Armour_Reactive",
          "cost": 1802440,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "cobra_mk_v",
      "fdSymbol": "CobraMkV",
      "name": "Cobra Mk V",
      "manufacturer": "Faulcon DeLacy",
      "class": 1,
      "hullCost": 1477085,
      "retailCost": 1989461,
      "speed": 291,
      "boost": 412,
      "boostEnergy": 10,
      "hullMass": 150,
      "masslock": 8,
      "baseShieldStrength": 160,
      "baseArmour": 180,
      "hardness": 40,
      "heatCapacity": 245,
      "crew": 3,
      "pitch": 45.61,
      "roll": 121.62,
      "yaw": 33.45,
      "reserveFuelCapacity": 0.49,
      "slots": {
        "core": [
          4,
          4,
          4,
          3,
          4,
          3,
          4
        ],
        "hardpoints": [
          2,
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          5,
          4,
          4,
          4,
          3,
          3,
          3,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 3,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 4,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size4",
          "kind": "optional",
          "size": 4,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "size": 3,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "size": 3,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size3",
          "kind": "optional",
          "size": 3,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size3_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size4_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class3",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_DockingComputer_Advanced",
          "moduleName": "Advanced Docking Computer"
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "CobraMkV_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "CobraMkV_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "CobraMkV_Armour_Grade2",
          "cost": 795784,
          "mass": 14,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "CobraMkV_Armour_Grade3",
          "cost": 1790514,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "CobraMkV_Armour_Mirrored",
          "cost": 4177866,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "CobraMkV_Armour_Reactive",
          "cost": 4689157,
          "mass": 27,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "imperial_corsair",
      "fdSymbol": "Corsair",
      "name": "Corsair",
      "manufacturer": "Gutamaya",
      "class": 2,
      "hullCost": 76884160,
      "retailCost": 79304750,
      "speed": 280,
      "boost": 355,
      "boostEnergy": 19,
      "hullMass": 265,
      "masslock": 17,
      "baseShieldStrength": 235,
      "baseArmour": 270,
      "hardness": 65,
      "heatCapacity": 230,
      "crew": 2,
      "pitch": 26,
      "roll": 80,
      "yaw": 10,
      "reserveFuelCapacity": 0.41,
      "slots": {
        "core": [
          7,
          7,
          5,
          4,
          7,
          6,
          5
        ],
        "hardpoints": [
          3,
          3,
          3,
          2,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          6,
          6,
          5,
          5,
          5,
          4,
          3,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 7,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 7,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 6,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size4",
          "kind": "optional",
          "size": 4,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "size": 3,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size2",
          "kind": "optional",
          "size": 2,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size7_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size7_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size6_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot09_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Corsair_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Corsair_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Corsair_Armour_Grade2",
          "cost": 31721900,
          "mass": 32,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Corsair_Armour_Grade3",
          "cost": 71374270,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Corsair_Armour_Mirrored",
          "cost": 166539970,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Corsair_Armour_Reactive",
          "cost": 186921290,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "diamondback_explorer",
      "fdSymbol": "DiamondBackXL",
      "name": "Diamondback Explorer",
      "manufacturer": "Lakon",
      "class": 1,
      "hullCost": 1638277,
      "retailCost": 1894760,
      "speed": 260,
      "boost": 340,
      "boostEnergy": 13,
      "hullMass": 260,
      "masslock": 10,
      "baseShieldStrength": 150,
      "baseArmour": 150,
      "hardness": 42,
      "heatCapacity": 351,
      "crew": 1,
      "pitch": 35,
      "roll": 90,
      "yaw": 13,
      "reserveFuelCapacity": 0.52,
      "slots": {
        "core": [
          4,
          4,
          5,
          3,
          4,
          3,
          5
        ],
        "hardpoints": [
          3,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          4,
          4,
          3,
          3,
          2,
          2,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 3,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 4,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size4",
          "kind": "optional",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size3_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size4_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "DiamondBackXL_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "DiamondBackXL_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "DiamondBackXL_Armour_Grade2",
          "cost": 757904,
          "mass": 23,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "DiamondBackXL_Armour_Grade3",
          "cost": 1705284,
          "mass": 47,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "DiamondBackXL_Armour_Mirrored",
          "cost": 3978996,
          "mass": 26,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "DiamondBackXL_Armour_Reactive",
          "cost": 4465949,
          "mass": 47,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "diamondback_scout",
      "fdSymbol": "DiamondBack",
      "name": "Diamondback Scout",
      "manufacturer": "Lakon",
      "class": 1,
      "hullCost": 463926,
      "retailCost": 564329,
      "speed": 280,
      "boost": 380,
      "boostEnergy": 10,
      "hullMass": 170,
      "masslock": 8,
      "baseShieldStrength": 120,
      "baseArmour": 120,
      "hardness": 40,
      "heatCapacity": 346,
      "crew": 1,
      "pitch": 42,
      "roll": 100,
      "yaw": 15,
      "reserveFuelCapacity": 0.49,
      "slots": {
        "core": [
          4,
          4,
          4,
          2,
          3,
          2,
          4
        ],
        "hardpoints": [
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          3,
          3,
          3,
          2,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 2,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 2,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size2_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size2_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "DiamondBack_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "DiamondBack_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "DiamondBack_Armour_Grade2",
          "cost": 225731,
          "mass": 13,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "DiamondBack_Armour_Grade3",
          "cost": 507896,
          "mass": 26,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "DiamondBack_Armour_Mirrored",
          "cost": 1185090,
          "mass": 26,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "DiamondBack_Armour_Reactive",
          "cost": 1330123,
          "mass": 26,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "dolphin",
      "fdSymbol": "Dolphin",
      "name": "Dolphin",
      "manufacturer": "Saud Kruger",
      "class": 1,
      "hullCost": 1117906,
      "retailCost": 1337323,
      "speed": 250,
      "boost": 350,
      "boostEnergy": 10,
      "hullMass": 140,
      "masslock": 9,
      "baseShieldStrength": 110,
      "baseArmour": 110,
      "hardness": 35,
      "heatCapacity": 165,
      "crew": 1,
      "pitch": 30,
      "roll": 100,
      "yaw": 20,
      "reserveFuelCapacity": 0.5,
      "slots": {
        "core": [
          4,
          5,
          4,
          4,
          3,
          3,
          4
        ],
        "hardpoints": [
          1,
          1,
          0,
          0,
          0
        ],
        "optional": [
          5,
          4,
          4,
          3,
          2,
          2,
          2,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 1,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 1,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_PassengerCabin_Size5_Class1",
          "moduleName": "EC Passenger Cabin"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Dolphin_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Dolphin_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Dolphin_Armour_Grade2",
          "cost": 534929,
          "mass": 32,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Dolphin_Armour_Grade3",
          "cost": 1203590,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Dolphin_Armour_Mirrored",
          "cost": 2808378,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Dolphin_Armour_Reactive",
          "cost": 3152070,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "eagle",
      "fdSymbol": "Eagle",
      "name": "Eagle",
      "manufacturer": "Core Dynamics",
      "class": 1,
      "hullCost": 10947,
      "retailCost": 44800,
      "speed": 240,
      "boost": 350,
      "boostEnergy": 8,
      "hullMass": 50,
      "masslock": 6,
      "baseShieldStrength": 60,
      "baseArmour": 40,
      "hardness": 28,
      "heatCapacity": 165,
      "crew": 1,
      "pitch": 50,
      "roll": 120,
      "yaw": 18,
      "reserveFuelCapacity": 0.34,
      "slots": {
        "core": [
          2,
          3,
          3,
          1,
          2,
          2,
          2
        ],
        "hardpoints": [
          1,
          1,
          1,
          0
        ],
        "optional": [
          3,
          2,
          {
            "class": 2,
            "name": "Military"
          },
          1,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 2,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 3,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 3,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 1,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 2,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 2,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 2,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 1,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 1,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size2",
          "kind": "optional",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 2,
          "index": 2,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot04_Size1",
          "kind": "optional",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size2_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size3_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size3_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size1_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size2_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size2_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size2_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Eagle_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Eagle_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Eagle_Armour_Grade2",
          "cost": 26880,
          "mass": 4,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Eagle_Armour_Grade3",
          "cost": 90048,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Eagle_Armour_Mirrored",
          "cost": 140089,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Eagle_Armour_Reactive",
          "cost": 150393,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "federal_assault_ship",
      "fdSymbol": "Federation_Dropship_MkII",
      "name": "Federal Assault Ship",
      "manufacturer": "Core Dynamics",
      "class": 2,
      "hullCost": 19111109,
      "retailCost": 19814210,
      "speed": 210,
      "boost": 350,
      "boostEnergy": 19,
      "hullMass": 480,
      "masslock": 14,
      "baseShieldStrength": 200,
      "baseArmour": 300,
      "hardness": 60,
      "heatCapacity": 286,
      "crew": 2,
      "pitch": 38,
      "roll": 90,
      "yaw": 19,
      "reserveFuelCapacity": 0.72,
      "slots": {
        "core": [
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "hardpoints": [
          3,
          3,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          5,
          5,
          4,
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          3,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 4,
          "index": 3,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 4,
          "index": 4,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "size": 3,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Federation_Dropship_MkII_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Federation_Dropship_MkII_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Federation_Dropship_MkII_Armour_Grade2",
          "cost": 7925682,
          "mass": 44,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Federation_Dropship_MkII_Armour_Grade3",
          "cost": 17832784,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Federation_Dropship_MkII_Armour_Mirrored",
          "cost": 42144814,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Federation_Dropship_MkII_Armour_Reactive",
          "cost": 46702081,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "federal_corvette",
      "fdSymbol": "Federation_Corvette",
      "name": "Federal Corvette",
      "manufacturer": "Core Dynamics",
      "class": 3,
      "hullCost": 183156068,
      "retailCost": 187969450,
      "speed": 200,
      "boost": 260,
      "boostEnergy": 27,
      "hullMass": 900,
      "masslock": 24,
      "baseShieldStrength": 555,
      "baseArmour": 370,
      "hardness": 70,
      "heatCapacity": 333,
      "crew": 4,
      "pitch": 28,
      "roll": 75,
      "yaw": 8,
      "reserveFuelCapacity": 1.13,
      "slots": {
        "core": [
          8,
          7,
          6,
          5,
          8,
          8,
          5
        ],
        "hardpoints": [
          4,
          4,
          3,
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          7,
          7,
          7,
          6,
          6,
          5,
          5,
          {
            "class": 5,
            "name": "Military"
          },
          {
            "class": 5,
            "name": "Military"
          },
          4,
          4,
          3,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 8,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 7,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 6,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 8,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 8,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint7",
          "kind": "utility",
          "size": 0,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint8",
          "kind": "utility",
          "size": 0,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "size": 7,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size7",
          "kind": "optional",
          "size": 7,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size7",
          "kind": "optional",
          "size": 7,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size6",
          "kind": "optional",
          "size": 6,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size6",
          "kind": "optional",
          "size": 6,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size5",
          "kind": "optional",
          "size": 5,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 5,
          "index": 7,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 5,
          "index": 8,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot10_Size4",
          "kind": "optional",
          "size": 4,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot11_Size4",
          "kind": "optional",
          "size": 4,
          "index": 10,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot12_Size3",
          "kind": "optional",
          "size": 3,
          "index": 11,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot13_Size1",
          "kind": "optional",
          "size": 1,
          "index": 12,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 13,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size8_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size7_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size6_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size8_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size8_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size7_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size7",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size6_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot10_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot11_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Federation_Corvette_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Federation_Corvette_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Federation_Corvette_Armour_Grade2",
          "cost": 75187780,
          "mass": 30,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Federation_Corvette_Armour_Grade3",
          "cost": 169172505,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Federation_Corvette_Armour_Mirrored",
          "cost": 399811021,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Federation_Corvette_Armour_Reactive",
          "cost": 443043995,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "federal_dropship",
      "fdSymbol": "Federation_Dropship",
      "name": "Federal Dropship",
      "manufacturer": "Core Dynamics",
      "class": 2,
      "hullCost": 13510106,
      "retailCost": 14314210,
      "speed": 180,
      "boost": 300,
      "boostEnergy": 19,
      "hullMass": 580,
      "masslock": 14,
      "baseShieldStrength": 200,
      "baseArmour": 300,
      "hardness": 60,
      "heatCapacity": 331,
      "crew": 2,
      "pitch": 30,
      "roll": 80,
      "yaw": 14,
      "reserveFuelCapacity": 0.83,
      "slots": {
        "core": [
          6,
          6,
          5,
          5,
          6,
          4,
          4
        ],
        "hardpoints": [
          3,
          2,
          2,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          5,
          5,
          4,
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          3,
          3,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "size": 5,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size4",
          "kind": "optional",
          "size": 4,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 4,
          "index": 4,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 4,
          "index": 5,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot07_Size3",
          "kind": "optional",
          "size": 3,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "size": 3,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size2",
          "kind": "optional",
          "size": 2,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot04_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Federation_Dropship_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Federation_Dropship_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Federation_Dropship_Armour_Grade2",
          "cost": 5725682,
          "mass": 44,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Federation_Dropship_Armour_Grade3",
          "cost": 12882784,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Federation_Dropship_Armour_Mirrored",
          "cost": 30446314,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Federation_Dropship_Armour_Reactive",
          "cost": 33738581,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "federal_gunship",
      "fdSymbol": "Federation_Gunship",
      "name": "Federal Gunship",
      "manufacturer": "Core Dynamics",
      "class": 2,
      "hullCost": 34814912,
      "retailCost": 35814210,
      "speed": 170,
      "boost": 280,
      "boostEnergy": 23,
      "hullMass": 580,
      "masslock": 14,
      "baseShieldStrength": 250,
      "baseArmour": 350,
      "hardness": 60,
      "heatCapacity": 325,
      "crew": 2,
      "pitch": 25,
      "roll": 80,
      "yaw": 18,
      "reserveFuelCapacity": 0.82,
      "slots": {
        "core": [
          6,
          6,
          5,
          5,
          7,
          5,
          4
        ],
        "hardpoints": [
          3,
          2,
          2,
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          6,
          5,
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          {
            "class": 4,
            "name": "Military"
          },
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 5,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "size": 5,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 4,
          "index": 3,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 4,
          "index": 4,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military03",
          "kind": "optional",
          "size": 4,
          "index": 5,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size5_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Federation_Gunship_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Federation_Gunship_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Federation_Gunship_Armour_Grade2",
          "cost": 14325682,
          "mass": 44,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Federation_Gunship_Armour_Grade3",
          "cost": 32232784,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Federation_Gunship_Armour_Mirrored",
          "cost": 76176814,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Federation_Gunship_Armour_Reactive",
          "cost": 84414081,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "fer_de_lance",
      "fdSymbol": "FerDeLance",
      "name": "Fer-de-Lance",
      "manufacturer": "Zorgon Peterson",
      "class": 2,
      "hullCost": 51242363,
      "retailCost": 51567040,
      "speed": 260,
      "boost": 350,
      "boostEnergy": 19,
      "hullMass": 250,
      "masslock": 12,
      "baseShieldStrength": 300,
      "baseArmour": 225,
      "hardness": 70,
      "heatCapacity": 224,
      "crew": 2,
      "pitch": 38,
      "roll": 90,
      "yaw": 12,
      "reserveFuelCapacity": 0.67,
      "slots": {
        "core": [
          6,
          5,
          4,
          4,
          6,
          4,
          3
        ],
        "hardpoints": [
          4,
          2,
          2,
          2,
          2,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          5,
          4,
          4,
          2,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 3,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size5_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size3_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "FerDeLance_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "FerDeLance_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "FerDeLance_Armour_Grade2",
          "cost": 20626816,
          "mass": 19,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "FerDeLance_Armour_Grade3",
          "cost": 46410336,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "FerDeLance_Armour_Mirrored",
          "cost": 109683094,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "FerDeLance_Armour_Reactive",
          "cost": 121543513,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "hauler",
      "fdSymbol": "Hauler",
      "name": "Hauler",
      "manufacturer": "Zorgon Peterson",
      "class": 1,
      "hullCost": 30308,
      "retailCost": 52720,
      "speed": 200,
      "boost": 300,
      "boostEnergy": 7,
      "hullMass": 14,
      "masslock": 6,
      "baseShieldStrength": 50,
      "baseArmour": 100,
      "hardness": 20,
      "heatCapacity": 123,
      "crew": 1,
      "pitch": 36,
      "roll": 100,
      "yaw": 14,
      "reserveFuelCapacity": 0.25,
      "slots": {
        "core": [
          2,
          2,
          2,
          1,
          1,
          1,
          2
        ],
        "hardpoints": [
          1,
          0,
          0
        ],
        "optional": [
          3,
          3,
          2,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 2,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 2,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 2,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 1,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 1,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 1,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 2,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 1,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size2",
          "kind": "optional",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size1",
          "kind": "optional",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size2_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size2_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size2_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size1_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size1_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size1_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size2_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size2_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Hauler_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Hauler_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Hauler_Armour_Grade2",
          "cost": 42176,
          "mass": 1,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Hauler_Armour_Grade3",
          "cost": 185047,
          "mass": 2,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Hauler_Armour_Mirrored",
          "cost": 270295,
          "mass": 2,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Hauler_Armour_Reactive",
          "cost": 282421,
          "mass": 2,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "imperial_clipper",
      "fdSymbol": "Empire_Clipper",
      "name": "Imperial Clipper",
      "manufacturer": "Gutamaya",
      "class": 3,
      "hullCost": 21116895,
      "retailCost": 22295860,
      "speed": 300,
      "boost": 380,
      "boostEnergy": 19,
      "hullMass": 400,
      "masslock": 12,
      "baseShieldStrength": 180,
      "baseArmour": 270,
      "hardness": 60,
      "heatCapacity": 304,
      "crew": 2,
      "pitch": 40,
      "roll": 80,
      "yaw": 18,
      "reserveFuelCapacity": 0.74,
      "slots": {
        "core": [
          6,
          6,
          5,
          5,
          6,
          5,
          4
        ],
        "hardpoints": [
          3,
          3,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          7,
          6,
          4,
          4,
          3,
          3,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 5,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "size": 7,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size4",
          "kind": "optional",
          "size": 4,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "size": 3,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "size": 3,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size5_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size6_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Empire_Trader_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Empire_Trader_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Empire_Trader_Armour_Grade2",
          "cost": 8918344,
          "mass": 30,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Empire_Trader_Armour_Grade3",
          "cost": 20066274,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Empire_Trader_Armour_Mirrored",
          "cost": 47423294,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Empire_Trader_Armour_Reactive",
          "cost": 52551342,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "imperial_courier",
      "fdSymbol": "Empire_Courier",
      "name": "Imperial Courier",
      "manufacturer": "Gutamaya",
      "class": 1,
      "hullCost": 2484137,
      "retailCost": 2542931,
      "speed": 280,
      "boost": 380,
      "boostEnergy": 10,
      "hullMass": 35,
      "masslock": 7,
      "baseShieldStrength": 200,
      "baseArmour": 80,
      "hardness": 30,
      "heatCapacity": 230,
      "crew": 1,
      "pitch": 38,
      "roll": 90,
      "yaw": 16,
      "reserveFuelCapacity": 0.41,
      "slots": {
        "core": [
          4,
          3,
          3,
          1,
          3,
          2,
          3
        ],
        "hardpoints": [
          2,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          3,
          3,
          2,
          2,
          2,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 3,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 3,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 1,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 2,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 3,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size2",
          "kind": "optional",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size3_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size3_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size1_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size2_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size3_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size2_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Empire_Courier_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Empire_Courier_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Empire_Courier_Armour_Grade2",
          "cost": 1017172,
          "mass": 4,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Empire_Courier_Armour_Grade3",
          "cost": 2288637,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Empire_Courier_Armour_Mirrored",
          "cost": 5408814,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Empire_Courier_Armour_Reactive",
          "cost": 5993688,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "imperial_cutter",
      "fdSymbol": "Cutter",
      "name": "Imperial Cutter",
      "manufacturer": "Gutamaya",
      "class": 3,
      "hullCost": 200493413,
      "retailCost": 208969451,
      "speed": 200,
      "boost": 320,
      "boostEnergy": 23,
      "hullMass": 1100,
      "masslock": 27,
      "baseShieldStrength": 600,
      "baseArmour": 400,
      "hardness": 70,
      "heatCapacity": 327,
      "crew": 4,
      "pitch": 18,
      "roll": 45,
      "yaw": 8,
      "reserveFuelCapacity": 1.16,
      "slots": {
        "core": [
          8,
          8,
          7,
          7,
          7,
          7,
          6
        ],
        "hardpoints": [
          4,
          3,
          3,
          2,
          2,
          2,
          2,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          8,
          8,
          6,
          6,
          6,
          5,
          5,
          {
            "class": 5,
            "name": "Military"
          },
          {
            "class": 5,
            "name": "Military"
          },
          4,
          3,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 8,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 8,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 7,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 7,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 7,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 6,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint7",
          "kind": "utility",
          "size": 0,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint8",
          "kind": "utility",
          "size": 0,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size8",
          "kind": "optional",
          "size": 8,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size8",
          "kind": "optional",
          "size": 8,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size6",
          "kind": "optional",
          "size": 6,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size6",
          "kind": "optional",
          "size": 6,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size5",
          "kind": "optional",
          "size": 5,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 5,
          "index": 7,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 5,
          "index": 8,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot10_Size4",
          "kind": "optional",
          "size": 4,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot11_Size3",
          "kind": "optional",
          "size": 3,
          "index": 10,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot12_Size1",
          "kind": "optional",
          "size": 1,
          "index": 11,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 12,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size8_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size8_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size7_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size7_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size7_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size6_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size8",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size8_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size8",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size7_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot10_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Cutter_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Cutter_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Cutter_Armour_Grade2",
          "cost": 83587780,
          "mass": 30,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Cutter_Armour_Grade3",
          "cost": 188072505,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Cutter_Armour_Mirrored",
          "cost": 444478021,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Cutter_Armour_Reactive",
          "cost": 492540995,
          "mass": 60,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "imperial_eagle",
      "fdSymbol": "Empire_Eagle",
      "name": "Imperial Eagle",
      "manufacturer": "Gutamaya",
      "class": 1,
      "hullCost": 73023,
      "retailCost": 110830,
      "speed": 300,
      "boost": 400,
      "boostEnergy": 8,
      "hullMass": 50,
      "masslock": 6,
      "baseShieldStrength": 80,
      "baseArmour": 60,
      "hardness": 28,
      "heatCapacity": 163,
      "crew": 1,
      "pitch": 40,
      "roll": 100,
      "yaw": 15,
      "reserveFuelCapacity": 0.37,
      "slots": {
        "core": [
          3,
          3,
          3,
          1,
          2,
          2,
          2
        ],
        "hardpoints": [
          2,
          1,
          1,
          0
        ],
        "optional": [
          3,
          2,
          {
            "class": 2,
            "name": "Military"
          },
          1,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 3,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 3,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 3,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 1,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 2,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 2,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 2,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 1,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size2",
          "kind": "optional",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 2,
          "index": 2,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot04_Size1",
          "kind": "optional",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size3_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size3_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size3_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size1_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size2_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size2_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size2_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Empire_Eagle_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Empire_Eagle_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Empire_Eagle_Armour_Grade2",
          "cost": 66495,
          "mass": 4,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Empire_Eagle_Armour_Grade3",
          "cost": 222758,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Empire_Eagle_Armour_Mirrored",
          "cost": 346549,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Empire_Eagle_Armour_Reactive",
          "cost": 372039,
          "mass": 8,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "keelback",
      "fdSymbol": "Keelback",
      "name": "Keelback",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 2946463,
      "retailCost": 3126154,
      "speed": 200,
      "boost": 300,
      "boostEnergy": 10,
      "hullMass": 180,
      "masslock": 8,
      "baseShieldStrength": 135,
      "baseArmour": 270,
      "hardness": 45,
      "heatCapacity": 215,
      "crew": 2,
      "pitch": 27,
      "roll": 100,
      "yaw": 15,
      "reserveFuelCapacity": 0.39,
      "slots": {
        "core": [
          4,
          4,
          4,
          1,
          3,
          2,
          4
        ],
        "hardpoints": [
          2,
          2,
          1,
          1,
          0,
          0,
          0
        ],
        "optional": [
          5,
          5,
          4,
          3,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 1,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 2,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size1_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size2_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Independant_Trader_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Independant_Trader_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Independant_Trader_Armour_Grade2",
          "cost": 1250461,
          "mass": 12,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Independant_Trader_Armour_Grade3",
          "cost": 2813538,
          "mass": 23,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Independant_Trader_Armour_Mirrored",
          "cost": 6649329,
          "mass": 23,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Independant_Trader_Armour_Reactive",
          "cost": 7368344,
          "mass": 23,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "kestrel",
      "fdSymbol": "Kestrel",
      "name": "Kestrel Mk II",
      "manufacturer": "Core Dynamics",
      "class": 1,
      "hullCost": 13776380,
      "retailCost": 14273820,
      "speed": 271,
      "boost": 360,
      "boostEnergy": 16,
      "hullMass": 190,
      "masslock": 10,
      "baseShieldStrength": 225,
      "baseArmour": 70,
      "hardness": 55,
      "heatCapacity": 237,
      "crew": 1,
      "pitch": 51.4,
      "roll": 123.36,
      "yaw": 24.67,
      "reserveFuelCapacity": 0.57,
      "slots": {
        "core": [
          5,
          5,
          4,
          1,
          5,
          2,
          4
        ],
        "hardpoints": [
          3,
          3,
          3,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          5,
          4,
          {
            "class": 4,
            "name": "Military"
          },
          3,
          2,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 5,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 1,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 5,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 2,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size5_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size1_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size5_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size2_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_MultiCannon_Fixed_Small",
          "moduleName": "Multi-Cannon"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_MultiCannon_Fixed_Small",
          "moduleName": "Multi-Cannon"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot04_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_DockingComputer_Advanced",
          "moduleName": "Advanced Docking Computer"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "SmallCombat01_NX_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "SmallCombat01_NX_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "SmallCombat01_NX_Armour_Grade2",
          "cost": 1970246,
          "mass": 17,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "SmallCombat01_NX_Armour_Grade3",
          "cost": 4433053,
          "mass": 35,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "SmallCombat01_NX_Armour_Mirrored",
          "cost": 10476783,
          "mass": 35,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "SmallCombat01_NX_Armour_Reactive",
          "cost": 11609674,
          "mass": 35,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "krait_mkii",
      "fdSymbol": "Krait_MkII",
      "name": "Krait Mk II",
      "manufacturer": "Faulcon DeLacy",
      "class": 2,
      "hullCost": 44160710,
      "retailCost": 45814205,
      "speed": 240,
      "boost": 330,
      "boostEnergy": 13,
      "hullMass": 320,
      "masslock": 16,
      "baseShieldStrength": 220,
      "baseArmour": 220,
      "hardness": 55,
      "heatCapacity": 300,
      "crew": 3,
      "pitch": 26,
      "roll": 90,
      "yaw": 10,
      "reserveFuelCapacity": 0.63,
      "slots": {
        "core": [
          7,
          6,
          5,
          4,
          7,
          6,
          5
        ],
        "hardpoints": [
          3,
          3,
          3,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          6,
          5,
          5,
          4,
          3,
          3,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 7,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 6,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "size": 5,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size4",
          "kind": "optional",
          "size": 4,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "size": 3,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size3",
          "kind": "optional",
          "size": 3,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size7_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size6_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Krait_MkII_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Krait_MkII_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Krait_MkII_Armour_Grade2",
          "cost": 18325682,
          "mass": 36,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Krait_MkII_Armour_Grade3",
          "cost": 41232784,
          "mass": 67,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Krait_MkII_Armour_Mirrored",
          "cost": 97446814,
          "mass": 67,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Krait_MkII_Armour_Reactive",
          "cost": 88322097,
          "mass": 67,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "krait_phantom",
      "fdSymbol": "Krait_Phantom",
      "name": "Krait Phantom",
      "manufacturer": "Faulcon DeLacy",
      "class": 2,
      "hullCost": 35741519,
      "retailCost": 37472252,
      "speed": 250,
      "boost": 350,
      "boostEnergy": 13,
      "hullMass": 270,
      "masslock": 14,
      "baseShieldStrength": 200,
      "baseArmour": 180,
      "hardness": 55,
      "heatCapacity": 300,
      "crew": 2,
      "pitch": 26,
      "roll": 90,
      "yaw": 10,
      "reserveFuelCapacity": 0.63,
      "slots": {
        "core": [
          7,
          6,
          5,
          4,
          7,
          6,
          5
        ],
        "hardpoints": [
          3,
          3,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          5,
          5,
          5,
          3,
          3,
          3,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 7,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 6,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "size": 5,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "size": 3,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "size": 3,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size3",
          "kind": "optional",
          "size": 3,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size7_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size6_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Krait_Light_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Krait_Light_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Krait_Light_Armour_Grade2",
          "cost": 14988900,
          "mass": 26,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Krait_Light_Armour_Grade3",
          "cost": 33725026,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Krait_Light_Armour_Mirrored",
          "cost": 79703480,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Krait_Light_Armour_Reactive",
          "cost": 88322097,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "mamba",
      "fdSymbol": "Mamba",
      "name": "Mamba",
      "manufacturer": "Zorgon Peterson",
      "class": 2,
      "hullCost": 55442918,
      "retailCost": 55867040,
      "speed": 310,
      "boost": 380,
      "boostEnergy": 17,
      "hullMass": 250,
      "masslock": 12,
      "baseShieldStrength": 270,
      "baseArmour": 230,
      "hardness": 70,
      "heatCapacity": 165,
      "crew": 2,
      "pitch": 27,
      "roll": 80,
      "yaw": 10,
      "reserveFuelCapacity": 0.5,
      "slots": {
        "core": [
          6,
          5,
          4,
          4,
          6,
          4,
          3
        ],
        "hardpoints": [
          4,
          3,
          3,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          5,
          4,
          3,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 3,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size3_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Mamba_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Mamba_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Mamba_Armour_Grade2",
          "cost": 22346816,
          "mass": 19,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Mamba_Armour_Grade3",
          "cost": 50280336,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Mamba_Armour_Mirrored",
          "cost": 118829194,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Mamba_Armour_Reactive",
          "cost": 131678613,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "mandalay",
      "fdSymbol": "Mandalay",
      "name": "Mandalay",
      "manufacturer": "Zorgon Peterson",
      "class": 2,
      "hullCost": 16527192,
      "retailCost": 17639220,
      "speed": 280,
      "boost": 350,
      "boostEnergy": 14,
      "hullMass": 230,
      "masslock": 11,
      "baseShieldStrength": 220,
      "baseArmour": 230,
      "hardness": 55,
      "heatCapacity": 250,
      "crew": 2,
      "pitch": 35,
      "roll": 96,
      "yaw": 28,
      "reserveFuelCapacity": 0.52,
      "slots": {
        "core": [
          5,
          5,
          5,
          4,
          5,
          5,
          5
        ],
        "hardpoints": [
          2,
          2,
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          5,
          4,
          4,
          3,
          3,
          2,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 5,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 5,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 5,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size4",
          "kind": "optional",
          "size": 4,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "size": 3,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "size": 3,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size5_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size5_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size5_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Mandalay_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Mandalay_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Mandalay_Armour_Grade2",
          "cost": 6191367,
          "mass": 19,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Mandalay_Armour_Grade3",
          "cost": 13930575,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Mandalay_Armour_Mirrored",
          "cost": 32922590,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Mandalay_Armour_Reactive",
          "cost": 36482626,
          "mass": 38,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "orca",
      "fdSymbol": "Orca",
      "name": "Orca",
      "manufacturer": "Saud Kruger",
      "class": 3,
      "hullCost": 47800723,
      "retailCost": 48539887,
      "speed": 300,
      "boost": 380,
      "boostEnergy": 16,
      "hullMass": 290,
      "masslock": 16,
      "baseShieldStrength": 220,
      "baseArmour": 220,
      "hardness": 55,
      "heatCapacity": 262,
      "crew": 2,
      "pitch": 25,
      "roll": 55,
      "yaw": 18,
      "reserveFuelCapacity": 0.79,
      "slots": {
        "core": [
          5,
          6,
          5,
          6,
          5,
          4,
          5
        ],
        "hardpoints": [
          3,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          5,
          5,
          5,
          4,
          3,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 5,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 6,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 5,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "size": 5,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size4",
          "kind": "optional",
          "size": 4,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size3",
          "kind": "optional",
          "size": 3,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size5_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size6_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size5_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_PassengerCabin_Size6_Class1",
          "moduleName": "EC Passenger Cabin"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_PassengerCabin_Size4_Class1",
          "moduleName": "EC Passenger Cabin"
        },
        {
          "slotName": "Slot03_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot05_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Orca_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Orca_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Orca_Armour_Grade2",
          "cost": 19415954,
          "mass": 21,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Orca_Armour_Grade3",
          "cost": 43685898,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Orca_Armour_Mirrored",
          "cost": 103244339,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Orca_Armour_Reactive",
          "cost": 114408513,
          "mass": 87,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "panther_clipper",
      "fdSymbol": "PantherClipper",
      "name": "Panther Clipper Mk II",
      "manufacturer": "Zorgon Peterson",
      "class": 3,
      "hullCost": 286905678,
      "retailCost": 301348586,
      "speed": 181,
      "boost": 250,
      "boostEnergy": 19,
      "hullMass": 1200,
      "masslock": 27,
      "baseShieldStrength": 350,
      "baseArmour": 620,
      "hardness": 70,
      "heatCapacity": 250,
      "crew": 4,
      "pitch": 18,
      "roll": 20,
      "yaw": 10,
      "reserveFuelCapacity": 1.16,
      "slots": {
        "core": [
          8,
          8,
          7,
          5,
          7,
          5,
          7
        ],
        "hardpoints": [
          3,
          3,
          2,
          2,
          2,
          2,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          {
            "class": 8,
            "name": "Cargo"
          },
          8,
          {
            "class": 7,
            "name": "Cargo"
          },
          7,
          6,
          6,
          6,
          5,
          5,
          4,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 8,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 8,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 7,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 5,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 7,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint8",
          "kind": "hardpoint",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint9",
          "kind": "hardpoint",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint10",
          "kind": "hardpoint",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Cargo",
          "kind": "optional",
          "size": 8,
          "index": 0,
          "group": null,
          "label": "Cargo",
          "eligible": [
            "cr",
            "crl",
            "ft"
          ]
        },
        {
          "slotName": "Slot02_Size8",
          "kind": "optional",
          "size": 8,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Cargo",
          "kind": "optional",
          "size": 7,
          "index": 2,
          "group": null,
          "label": "Cargo",
          "eligible": [
            "cr",
            "crl",
            "ft"
          ]
        },
        {
          "slotName": "Slot04_Size7",
          "kind": "optional",
          "size": 7,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size6",
          "kind": "optional",
          "size": 6,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size6",
          "kind": "optional",
          "size": 6,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size6",
          "kind": "optional",
          "size": 6,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size5",
          "kind": "optional",
          "size": 5,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size5",
          "kind": "optional",
          "size": 5,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size4",
          "kind": "optional",
          "size": 4,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot11_Size2",
          "kind": "optional",
          "size": 2,
          "index": 10,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot12_Size1",
          "kind": "optional",
          "size": 1,
          "index": 11,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 12,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size8_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size8_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size5_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size7_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Cargo",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size7_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size8",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size7_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot06_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot07_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot11_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_DockingComputer_Advanced",
          "moduleName": "Advanced Docking Computer"
        },
        {
          "slotName": "Slot12_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "PantherMkII_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "PantherMkII_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "PantherMkII_Armour_Grade2",
          "cost": 120839434,
          "mass": 75,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "PantherMkII_Armour_Grade3",
          "cost": 271213728,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "PantherMkII_Armour_Mirrored",
          "cost": 632832030,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "PantherMkII_Armour_Reactive",
          "cost": 710278615,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "python",
      "fdSymbol": "Python",
      "name": "Python",
      "manufacturer": "Faulcon DeLacy",
      "class": 2,
      "hullCost": 55324684,
      "retailCost": 56978179,
      "speed": 230,
      "boost": 300,
      "boostEnergy": 23,
      "hullMass": 350,
      "masslock": 17,
      "baseShieldStrength": 260,
      "baseArmour": 260,
      "hardness": 65,
      "heatCapacity": 300,
      "crew": 2,
      "pitch": 29,
      "roll": 90,
      "yaw": 10,
      "reserveFuelCapacity": 0.83,
      "slots": {
        "core": [
          7,
          6,
          5,
          4,
          7,
          6,
          5
        ],
        "hardpoints": [
          3,
          3,
          3,
          2,
          2,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          6,
          6,
          5,
          5,
          4,
          3,
          3,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 7,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 6,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size4",
          "kind": "optional",
          "size": 4,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size3",
          "kind": "optional",
          "size": 3,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "size": 3,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size2",
          "kind": "optional",
          "size": 2,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size7_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size6_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Python_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Python_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Python_Armour_Grade2",
          "cost": 22791271,
          "mass": 26,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Python_Armour_Grade3",
          "cost": 51280361,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Python_Armour_Mirrored",
          "cost": 121192586,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Python_Armour_Reactive",
          "cost": 134297567,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "python_nx",
      "fdSymbol": "Python_NX",
      "name": "Python Mk II",
      "manufacturer": "Faulcon DeLacy",
      "class": 2,
      "hullCost": 64743724,
      "retailCost": 67527359,
      "speed": 256,
      "boost": 345,
      "boostEnergy": 19,
      "hullMass": 450,
      "masslock": 17,
      "baseShieldStrength": 335,
      "baseArmour": 280,
      "hardness": 70,
      "heatCapacity": 316,
      "crew": 2,
      "pitch": 37.72,
      "roll": 92.76,
      "yaw": 12.74,
      "reserveFuelCapacity": 0.83,
      "slots": {
        "core": [
          6,
          6,
          5,
          4,
          6,
          5,
          4
        ],
        "hardpoints": [
          3,
          3,
          3,
          3,
          2,
          2,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          4,
          3,
          2,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 6,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 5,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size6_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size5_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Python_NX_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Python_NX_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Python_NX_Armour_Grade2",
          "cost": 23702103,
          "mass": 26,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Python_NX_Armour_Grade3",
          "cost": 53329732,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Python_NX_Armour_Mirrored",
          "cost": 126035933,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Python_NX_Armour_Reactive",
          "cost": 139664643,
          "mass": 53,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "sidewinder",
      "fdSymbol": "SideWinder",
      "name": "Sidewinder",
      "manufacturer": "Faulcon DeLacy",
      "class": 1,
      "hullCost": 4588,
      "retailCost": 32000,
      "speed": 220,
      "boost": 320,
      "boostEnergy": 7,
      "hullMass": 25,
      "masslock": 6,
      "baseShieldStrength": 40,
      "baseArmour": 60,
      "hardness": 20,
      "heatCapacity": 140,
      "crew": 1,
      "pitch": 42,
      "roll": 110,
      "yaw": 16,
      "reserveFuelCapacity": 0.3,
      "slots": {
        "core": [
          2,
          2,
          2,
          1,
          1,
          1,
          1
        ],
        "hardpoints": [
          1,
          1,
          0,
          0
        ],
        "optional": [
          2,
          2,
          1,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 2,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 2,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 2,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 1,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 1,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 1,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 1,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 1,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 1,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size2",
          "kind": "optional",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size2",
          "kind": "optional",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size1",
          "kind": "optional",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size1",
          "kind": "optional",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size2_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size2_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size2_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size1_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size1_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size1_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size1_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Gimbal_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Gimbal_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size2_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot02_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "SideWinder_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "SideWinder_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "SideWinder_Armour_Grade2",
          "cost": 25600,
          "mass": 2,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "SideWinder_Armour_Grade3",
          "cost": 80320,
          "mass": 4,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "SideWinder_Armour_Mirrored",
          "cost": 132064,
          "mass": 4,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "SideWinder_Armour_Reactive",
          "cost": 139424,
          "mass": 4,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "type_10_defender",
      "fdSymbol": "Type10",
      "name": "Type-10 Defender",
      "manufacturer": "Lakon",
      "class": 3,
      "hullCost": 121334619,
      "retailCost": 124755342,
      "speed": 179,
      "boost": 219,
      "boostEnergy": 19,
      "hullMass": 1200,
      "masslock": 26,
      "baseShieldStrength": 320,
      "baseArmour": 580,
      "hardness": 75,
      "heatCapacity": 335,
      "crew": 4,
      "pitch": 20,
      "roll": 20,
      "yaw": 8,
      "reserveFuelCapacity": 0.77,
      "slots": {
        "core": [
          8,
          7,
          7,
          5,
          7,
          4,
          6
        ],
        "hardpoints": [
          3,
          3,
          3,
          3,
          2,
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        "optional": [
          8,
          7,
          6,
          5,
          4,
          4,
          3,
          3,
          2,
          {
            "class": 5,
            "name": "Military"
          },
          {
            "class": 5,
            "name": "Military"
          },
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 8,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 7,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 7,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 6,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 3,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint8",
          "kind": "hardpoint",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint9",
          "kind": "hardpoint",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint5",
          "kind": "utility",
          "size": 0,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint6",
          "kind": "utility",
          "size": 0,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint7",
          "kind": "utility",
          "size": 0,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint8",
          "kind": "utility",
          "size": 0,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size8",
          "kind": "optional",
          "size": 8,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size7",
          "kind": "optional",
          "size": 7,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size4",
          "kind": "optional",
          "size": 4,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size4",
          "kind": "optional",
          "size": 4,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size3",
          "kind": "optional",
          "size": 3,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "size": 3,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size2",
          "kind": "optional",
          "size": 2,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 5,
          "index": 9,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Military02",
          "kind": "optional",
          "size": 5,
          "index": 10,
          "group": null,
          "label": "Military",
          "eligible": [
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot12_Size1",
          "kind": "optional",
          "size": 1,
          "index": 11,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 12,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size7_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size6_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size6_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size8",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size7_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size7",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size6_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot05_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot07_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Type9_Military_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Type9_Military_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Type9_Military_Armour_Grade2",
          "cost": 49902136,
          "mass": 75,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Type9_Military_Armour_Grade3",
          "cost": 112279807,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Type9_Military_Armour_Mirrored",
          "cost": 265354612,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Type9_Military_Armour_Reactive",
          "cost": 294048341,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "type_11_prospector",
      "fdSymbol": "Type11",
      "name": "Type-11 Prospector",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 66346710,
      "retailCost": 67861850,
      "speed": 272,
      "boost": 367,
      "boostEnergy": 25,
      "hullMass": 320,
      "masslock": 16,
      "baseShieldStrength": 275,
      "baseArmour": 350,
      "hardness": 58,
      "heatCapacity": 289,
      "crew": 3,
      "pitch": 25,
      "roll": 37.5,
      "yaw": 22,
      "reserveFuelCapacity": 0.77,
      "slots": {
        "core": [
          6,
          5,
          5,
          3,
          7,
          3,
          5
        ],
        "hardpoints": [
          {
            "class": 3,
            "name": "Mining"
          },
          {
            "class": 2,
            "name": "Mining"
          },
          {
            "class": 2,
            "name": "Mining"
          },
          2,
          {
            "class": 1,
            "name": "Mining"
          },
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          6,
          6,
          5,
          5,
          {
            "class": 5,
            "name": "Limpets"
          },
          {
            "class": 5,
            "name": "Fighter"
          },
          4,
          3,
          2,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 3,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 7,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": "Mining",
          "eligible": [
            "abl",
            "ml",
            "mvr",
            "pwa",
            "scl",
            "sdm"
          ]
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": "Mining",
          "eligible": [
            "abl",
            "ml",
            "pwa",
            "scl",
            "sdm"
          ]
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": "Mining",
          "eligible": [
            "abl",
            "ml",
            "pwa",
            "scl",
            "sdm"
          ]
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": "Mining",
          "eligible": [
            "abl",
            "ml",
            "pwa",
            "scl",
            "sdm"
          ]
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint8",
          "kind": "hardpoint",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Limpets",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": "Limpets",
          "eligible": [
            "cc",
            "dtl",
            "fx",
            "hb",
            "mlc",
            "pc",
            "rpl",
            "rcpl",
            "rsl"
          ]
        },
        {
          "slotName": "Fighter",
          "kind": "optional",
          "size": 5,
          "index": 6,
          "group": null,
          "label": "Fighter",
          "eligible": [
            "fh"
          ]
        },
        {
          "slotName": "Slot08_Size4",
          "kind": "optional",
          "size": 4,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size3",
          "kind": "optional",
          "size": 3,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size2",
          "kind": "optional",
          "size": 2,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot11_Size1",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot12_Size1",
          "kind": "optional",
          "size": 1,
          "index": 11,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 12,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size3_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size7_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint7",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint8",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot11_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_DockingComputer_Advanced",
          "moduleName": "Advanced Docking Computer"
        },
        {
          "slotName": "Slot12_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "LakonMiner_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "LakonMiner_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "LakonMiner_Armour_Grade2",
          "cost": 27144740,
          "mass": 32,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "LakonMiner_Armour_Grade3",
          "cost": 61075670,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "LakonMiner_Armour_Mirrored",
          "cost": 144342150,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "LakonMiner_Armour_Reactive",
          "cost": 159950380,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "type_6_transporter",
      "fdSymbol": "Type6",
      "name": "Type-6 Transporter",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 866622,
      "retailCost": 1045945,
      "speed": 220,
      "boost": 350,
      "boostEnergy": 10,
      "hullMass": 155,
      "masslock": 8,
      "baseShieldStrength": 90,
      "baseArmour": 180,
      "hardness": 35,
      "heatCapacity": 179,
      "crew": 1,
      "pitch": 30,
      "roll": 100,
      "yaw": 17,
      "reserveFuelCapacity": 0.39,
      "slots": {
        "core": [
          3,
          4,
          4,
          2,
          3,
          2,
          4
        ],
        "hardpoints": [
          1,
          1,
          0,
          0,
          0
        ],
        "optional": [
          5,
          5,
          4,
          4,
          3,
          2,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 3,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 2,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 2,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 1,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 1,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size4",
          "kind": "optional",
          "size": 4,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "size": 3,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size2",
          "kind": "optional",
          "size": 2,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size3_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size2_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size2_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot04_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot05_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Type6_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Type6_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Type6_Armour_Grade2",
          "cost": 418378,
          "mass": 12,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Type6_Armour_Grade3",
          "cost": 941350,
          "mass": 23,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Type6_Armour_Mirrored",
          "cost": 2224725,
          "mass": 23,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Type6_Armour_Reactive",
          "cost": 2465292,
          "mass": 23,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "type_7_transport",
      "fdSymbol": "Type7",
      "name": "Type-7 Transporter",
      "manufacturer": "Lakon",
      "class": 3,
      "hullCost": 16783094,
      "retailCost": 17472252,
      "speed": 180,
      "boost": 300,
      "boostEnergy": 10,
      "hullMass": 350,
      "masslock": 10,
      "baseShieldStrength": 155,
      "baseArmour": 340,
      "hardness": 54,
      "heatCapacity": 226,
      "crew": 1,
      "pitch": 22,
      "roll": 60,
      "yaw": 22,
      "reserveFuelCapacity": 0.52,
      "slots": {
        "core": [
          5,
          5,
          5,
          4,
          4,
          3,
          5
        ],
        "hardpoints": [
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          6,
          6,
          6,
          5,
          5,
          5,
          3,
          3,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 5,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 4,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 4,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 1,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 1,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "size": 6,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "size": 5,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size3",
          "kind": "optional",
          "size": 3,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "size": 3,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size2",
          "kind": "optional",
          "size": 2,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size1",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size5_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size4_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot04_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Type7_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Type7_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Type7_Armour_Grade2",
          "cost": 6988900,
          "mass": 32,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Type7_Armour_Grade3",
          "cost": 15725026,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Type7_Armour_Mirrored",
          "cost": 37163480,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Type7_Armour_Reactive",
          "cost": 41182097,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "type_8_transport",
      "fdSymbol": "Type8",
      "name": "Type-8 Transporter",
      "manufacturer": "Lakon",
      "class": 2,
      "hullCost": 34820576,
      "retailCost": 38453970,
      "speed": 200,
      "boost": 340,
      "boostEnergy": 10,
      "hullMass": 400,
      "masslock": 18,
      "baseShieldStrength": 228,
      "baseArmour": 440,
      "hardness": 58,
      "heatCapacity": 226,
      "crew": 1,
      "pitch": 28,
      "roll": 60,
      "yaw": 18,
      "reserveFuelCapacity": 0.52,
      "slots": {
        "core": [
          5,
          5,
          5,
          3,
          4,
          3,
          5
        ],
        "hardpoints": [
          2,
          1,
          1,
          1,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          7,
          6,
          6,
          6,
          5,
          5,
          4,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 5,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 5,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 3,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 4,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 5,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 1,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint6",
          "kind": "hardpoint",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "size": 7,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "size": 6,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size6",
          "kind": "optional",
          "size": 6,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size6",
          "kind": "optional",
          "size": 6,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "size": 5,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size4",
          "kind": "optional",
          "size": 4,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size2",
          "kind": "optional",
          "size": 2,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size5_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size3_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size4_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size5_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size7",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size7_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size5_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot06_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size4_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "moduleSymbol": "Int_SupercruiseAssist",
          "moduleName": "Supercruise Assist"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Type8_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Type8_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Type8_Armour_Grade2",
          "cost": 15381590,
          "mass": 32,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Type8_Armour_Grade3",
          "cost": 34608570,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Type8_Armour_Mirrored",
          "cost": 37163480,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Type8_Armour_Reactive",
          "cost": 90636000,
          "mass": 63,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "type_9_heavy",
      "fdSymbol": "Type9",
      "name": "Type-9 Heavy",
      "manufacturer": "Lakon",
      "class": 3,
      "hullCost": 72116858,
      "retailCost": 76555842,
      "speed": 130,
      "boost": 200,
      "boostEnergy": 19,
      "hullMass": 850,
      "masslock": 16,
      "baseShieldStrength": 240,
      "baseArmour": 480,
      "hardness": 65,
      "heatCapacity": 289,
      "crew": 4,
      "pitch": 20,
      "roll": 20,
      "yaw": 8,
      "reserveFuelCapacity": 0.77,
      "slots": {
        "core": [
          6,
          7,
          6,
          5,
          6,
          4,
          6
        ],
        "hardpoints": [
          2,
          2,
          2,
          1,
          1,
          0,
          0,
          0,
          0
        ],
        "optional": [
          8,
          8,
          7,
          6,
          5,
          4,
          4,
          3,
          3,
          2,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 6,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 7,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 6,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 5,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 6,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 6,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 2,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint5",
          "kind": "hardpoint",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size8",
          "kind": "optional",
          "size": 8,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size8",
          "kind": "optional",
          "size": 8,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size7",
          "kind": "optional",
          "size": 7,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size6",
          "kind": "optional",
          "size": 6,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "size": 5,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size4",
          "kind": "optional",
          "size": 4,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size4",
          "kind": "optional",
          "size": 4,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "size": 3,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size3",
          "kind": "optional",
          "size": 3,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot10_Size2",
          "kind": "optional",
          "size": 2,
          "index": 9,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot11_Size1",
          "kind": "optional",
          "size": 1,
          "index": 10,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 11,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size6_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size7_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size6_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size5_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size6_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size6_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size8",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size7_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size8",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size7_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size7",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size6_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot04_Size6",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size6_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot05_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size4_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot06_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot08_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Type9_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Type9_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Type9_Armour_Grade2",
          "cost": 30622336,
          "mass": 75,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Type9_Armour_Grade3",
          "cost": 68900257,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Type9_Armour_Mirrored",
          "cost": 162834275,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Type9_Armour_Reactive",
          "cost": 180442119,
          "mass": 150,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "viper",
      "fdSymbol": "Viper",
      "name": "Viper",
      "manufacturer": "Faulcon DeLacy",
      "class": 1,
      "hullCost": 96733,
      "retailCost": 142931,
      "speed": 320,
      "boost": 400,
      "boostEnergy": 10,
      "hullMass": 50,
      "masslock": 7,
      "baseShieldStrength": 105,
      "baseArmour": 70,
      "hardness": 35,
      "heatCapacity": 195,
      "crew": 1,
      "pitch": 35,
      "roll": 90,
      "yaw": 15,
      "reserveFuelCapacity": 0.41,
      "slots": {
        "core": [
          3,
          3,
          3,
          2,
          3,
          3,
          2
        ],
        "hardpoints": [
          2,
          2,
          1,
          1,
          0,
          0
        ],
        "optional": [
          3,
          3,
          {
            "class": 3,
            "name": "Military"
          },
          2,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 3,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 3,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 3,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 2,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 2,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size3_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size3_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size3_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size2_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size2_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size2_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": null,
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": null,
          "cost": 57172,
          "mass": 5,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": null,
          "cost": 128637,
          "mass": 9,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": null,
          "cost": 304014,
          "mass": 9,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": null,
          "cost": 336888,
          "mass": 9,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "viper_mk_iv",
      "fdSymbol": "ViperMkIV",
      "name": "Viper Mk IV",
      "manufacturer": "Faulcon DeLacy",
      "class": 1,
      "hullCost": 312797,
      "retailCost": 437931,
      "speed": 270,
      "boost": 340,
      "boostEnergy": 10,
      "hullMass": 190,
      "masslock": 7,
      "baseShieldStrength": 150,
      "baseArmour": 150,
      "hardness": 35,
      "heatCapacity": 209,
      "crew": 1,
      "pitch": 30,
      "roll": 90,
      "yaw": 12,
      "reserveFuelCapacity": 0.46,
      "slots": {
        "core": [
          4,
          4,
          4,
          2,
          3,
          3,
          4
        ],
        "hardpoints": [
          2,
          2,
          1,
          1,
          0,
          0
        ],
        "optional": [
          4,
          4,
          3,
          {
            "class": 3,
            "name": "Military"
          },
          2,
          2,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 4,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 2,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 3,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 3,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 4,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 2,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 2,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "size": 1,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "size": 1,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size4",
          "kind": "optional",
          "size": 4,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "size": 4,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "size": 3,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 3,
          "index": 3,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "size": 2,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size2",
          "kind": "optional",
          "size": 2,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot09_Size1",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 9,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size4_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size2_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size3_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size3_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size4_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint3",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint4",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot02_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "Slot03_Size3",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size3_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot05_Size2",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size1_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Viper_MkIV_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Viper_MkIV_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Viper_MkIV_Armour_Grade2",
          "cost": 175172,
          "mass": 5,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Viper_MkIV_Armour_Grade3",
          "cost": 394137,
          "mass": 9,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Viper_MkIV_Armour_Mirrored",
          "cost": 931479,
          "mass": 9,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Viper_MkIV_Armour_Reactive",
          "cost": 1032203,
          "mass": 9,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    },
    {
      "slug": "vulture",
      "fdSymbol": "Vulture",
      "name": "Vulture",
      "manufacturer": "Core Dynamics",
      "class": 1,
      "hullCost": 4692214,
      "retailCost": 4925615,
      "speed": 210,
      "boost": 340,
      "boostEnergy": 16,
      "hullMass": 230,
      "masslock": 10,
      "baseShieldStrength": 240,
      "baseArmour": 160,
      "hardness": 55,
      "heatCapacity": 237,
      "crew": 2,
      "pitch": 42,
      "roll": 110,
      "yaw": 17,
      "reserveFuelCapacity": 0.57,
      "slots": {
        "core": [
          4,
          5,
          4,
          3,
          5,
          4,
          3
        ],
        "hardpoints": [
          3,
          3,
          0,
          0,
          0,
          0
        ],
        "optional": [
          5,
          {
            "class": 5,
            "name": "Military"
          },
          4,
          2,
          1,
          1,
          1,
          1,
          {
            "class": 1,
            "name": "PlanetaryApproachSuite"
          }
        ]
      },
      "buildSlots": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "size": 4,
          "index": 0,
          "group": "pp",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "size": 5,
          "index": 1,
          "group": "t",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "size": 4,
          "index": 2,
          "group": "fsd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "size": 3,
          "index": 3,
          "group": "ls",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "size": 5,
          "index": 4,
          "group": "pd",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "size": 4,
          "index": 5,
          "group": "s",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "size": 3,
          "index": 6,
          "group": "ft",
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "size": 3,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "size": 3,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint1",
          "kind": "utility",
          "size": 0,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint2",
          "kind": "utility",
          "size": 0,
          "index": 1,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint3",
          "kind": "utility",
          "size": 0,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "TinyHardpoint4",
          "kind": "utility",
          "size": 0,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "size": 5,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Military01",
          "kind": "optional",
          "size": 5,
          "index": 1,
          "group": null,
          "label": "Military",
          "eligible": [
            "mahr",
            "hr",
            "scb",
            "mrp",
            "gsrp",
            "gmrp",
            "ghrp"
          ]
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "size": 4,
          "index": 2,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot04_Size2",
          "kind": "optional",
          "size": 2,
          "index": 3,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot05_Size1",
          "kind": "optional",
          "size": 1,
          "index": 4,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot06_Size1",
          "kind": "optional",
          "size": 1,
          "index": 5,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot07_Size1",
          "kind": "optional",
          "size": 1,
          "index": 6,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "Slot08_Size1",
          "kind": "optional",
          "size": 1,
          "index": 7,
          "group": null,
          "label": null,
          "eligible": null
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "size": 1,
          "index": 8,
          "group": null,
          "label": "Planetary Approach Suite",
          "eligible": [
            "pas"
          ]
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "size": null,
          "index": 0,
          "group": null,
          "label": null,
          "eligible": null
        }
      ],
      "defaultModules": [
        {
          "slotName": "PowerPlant",
          "kind": "core",
          "moduleSymbol": "Int_Powerplant_Size4_Class1",
          "moduleName": "Power Plant"
        },
        {
          "slotName": "MainEngines",
          "kind": "core",
          "moduleSymbol": "Int_Engine_Size5_Class1",
          "moduleName": "Thrusters"
        },
        {
          "slotName": "FrameShiftDrive",
          "kind": "core",
          "moduleSymbol": "Int_Hyperdrive_Size4_Class1",
          "moduleName": "Frame Shift Drive"
        },
        {
          "slotName": "LifeSupport",
          "kind": "core",
          "moduleSymbol": "Int_LifeSupport_Size3_Class1",
          "moduleName": "Life Support"
        },
        {
          "slotName": "PowerDistributor",
          "kind": "core",
          "moduleSymbol": "Int_PowerDistributor_Size5_Class1",
          "moduleName": "Power Distributor"
        },
        {
          "slotName": "Radar",
          "kind": "core",
          "moduleSymbol": "Int_Sensors_Size4_Class1",
          "moduleName": "Sensors"
        },
        {
          "slotName": "FuelTank",
          "kind": "core",
          "moduleSymbol": "Int_FuelTank_Size3_Class3",
          "moduleName": "Fuel Tank"
        },
        {
          "slotName": "Hardpoint1",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Hardpoint2",
          "kind": "hardpoint",
          "moduleSymbol": "Hpt_PulseLaser_Fixed_Small",
          "moduleName": "Pulse Laser"
        },
        {
          "slotName": "Slot01_Size5",
          "kind": "optional",
          "moduleSymbol": "Int_ShieldGenerator_Size5_Class1",
          "moduleName": "Shield Generator"
        },
        {
          "slotName": "Slot03_Size4",
          "kind": "optional",
          "moduleSymbol": "Int_CargoRack_Size3_Class1",
          "moduleName": "Cargo Rack"
        },
        {
          "slotName": "PlanetaryApproachSuite",
          "kind": "optional",
          "moduleSymbol": "Int_PlanetApproachSuite_Advanced",
          "moduleName": "Advanced Planetary Approach Suite (Odyssey)"
        },
        {
          "slotName": "Armour",
          "kind": "bulkhead",
          "moduleSymbol": "Vulture_Armour_Grade1",
          "moduleName": "Lightweight Alloy"
        }
      ],
      "bulkheads": [
        {
          "name": "Lightweight Alloy",
          "symbol": "Vulture_Armour_Grade1",
          "cost": 0,
          "mass": 0,
          "hullBoost": 0.8,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Reinforced Alloy",
          "symbol": "Vulture_Armour_Grade2",
          "cost": 1970246,
          "mass": 17,
          "hullBoost": 1.52,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Military Grade Composite",
          "symbol": "Vulture_Armour_Grade3",
          "cost": 4433053,
          "mass": 35,
          "hullBoost": 2.5,
          "kineticResistance": -0.2,
          "thermalResistance": 0,
          "explosiveResistance": -0.4,
          "causticResistance": 0
        },
        {
          "name": "Mirrored Surface Composite",
          "symbol": "Vulture_Armour_Mirrored",
          "cost": 10476783,
          "mass": 35,
          "hullBoost": 2.5,
          "kineticResistance": -0.75,
          "thermalResistance": 0.5,
          "explosiveResistance": -0.5,
          "causticResistance": 0
        },
        {
          "name": "Reactive Surface Composite",
          "symbol": "Vulture_Armour_Reactive",
          "cost": 11609674,
          "mass": 35,
          "hullBoost": 2.5,
          "kineticResistance": 0.25,
          "thermalResistance": -0.4,
          "explosiveResistance": 0.2,
          "causticResistance": 0
        }
      ]
    }
  ]
}
